<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 24 24"
    :class="['w-full h-auto', className]"
  >
    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
      <g stroke-dasharray="2">
        <path d="M12 21v1M21 12h1M12 3v-1M3 12h-1">
          <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.2s" values="4;2" />
        </path>
        <path d="M18.5 18.5l0.5 0.5M18.5 5.5l0.5 -0.5M5.5 5.5l-0.5 -0.5M5.5 18.5l-0.5 0.5">
          <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.2s" dur="0.2s" values="4;2" />
        </path>
      </g>
      <path fill="currentColor" d="M7 6 C7 12.08 11.92 17 18 17 C18.53 17 19.05 16.96 19.56 16.89 C17.95 19.36 15.17 21 12 21 C7.03 21 3 16.97 3 12 C3 8.83 4.64 6.05 7.11 4.44 C7.04 4.95 7 5.47 7 6 Z" opacity="0">
        <set attributeName="opacity" begin="0.5s" to="1" />
      </path>
    </g>
    <g fill="currentColor" fill-opacity="0">
      <path d="m15.22 6.03l2.53-1.94L14.56 4L13.5 1l-1.06 3l-3.19.09l2.53 1.94l-.91 3.06l2.63-1.81l2.63 1.81z">
        <animate id="t0" fill="freeze" attributeName="fill-opacity" begin="0.6s;t0.begin+6s" dur="0.4s" values="0;1" />
        <animate fill="freeze" attributeName="fill-opacity" begin="t0.begin+2.2s" dur="0.4s" values="1;0" />
      </path>
      <path d="M13.61 5.25L15.25 4l-2.06-.05L12.5 2l-.69 1.95L9.75 4l1.64 1.25l-.59 1.98l1.7-1.17l1.7 1.17z">
        <animate fill="freeze" attributeName="fill-opacity" begin="t0.begin+3s" dur="0.4s" values="0;1" />
        <animate fill="freeze" attributeName="fill-opacity" begin="t0.begin+5.2s" dur="0.4s" values="1;0" />
      </path>
      <path d="M19.61 12.25L21.25 11l-2.06-.05L18.5 9l-.69 1.95l-2.06.05l1.64 1.25l-.59 1.98l1.7-1.17l1.7 1.17z">
        <animate fill="freeze" attributeName="fill-opacity" begin="t0.begin+0.4s" dur="0.4s" values="0;1" />
        <animate fill="freeze" attributeName="fill-opacity" begin="t0.begin+2.8s" dur="0.4s" values="1;0" />
      </path>
      <path d="m20.828 9.731l1.876-1.439l-2.366-.067L19.552 6l-.786 2.225l-2.366.067l1.876 1.439L17.601 12l1.951-1.342L21.503 12z">
        <animate fill="freeze" attributeName="fill-opacity" begin="t0.begin+3.4s" dur="0.4s" values="0;1" />
        <animate fill="freeze" attributeName="fill-opacity" begin="t0.begin+5.6s" dur="0.4s" values="1;0" />
      </path>
    </g>
    <mask id="sunMask">
      <circle cx="12" cy="12" r="12" fill="#fff" />
      <circle cx="22" cy="2" r="3" fill="#fff">
        <animate fill="freeze" attributeName="cx" begin="0.1s" dur="0.4s" values="22;18" />
        <animate fill="freeze" attributeName="cy" begin="0.1s" dur="0.4s" values="2;6" />
        <animate fill="freeze" attributeName="r" begin="0.1s" dur="0.4s" values="3;12" />
      </circle>
      <circle cx="22" cy="2" r="1">
        <animate fill="freeze" attributeName="cx" begin="0.1s" dur="0.4s" values="22;18" />
        <animate fill="freeze" attributeName="cy" begin="0.1s" dur="0.4s" values="2;6" />
        <animate fill="freeze" attributeName="r" begin="0.1s" dur="0.4s" values="1;10" />
      </circle>
    </mask>
    <circle cx="12" cy="12" r="6" fill="currentColor" mask="url(#sunMask)">
      <set attributeName="opacity" begin="0.5s" to="0" />
      <animate fill="freeze" attributeName="r" begin="0.1s" dur="0.4s" values="6;10" />
    </circle>
  </svg>
</template>

<script>
  export default {
    name: 'SunIcon',
    props: {
      className: {
        type: String,
        default: '',
      },
    },
  }
</script>
